import { useState, useEffect } from "react";
import SideMenu from "../../features/sideMenu/SideMenu";
import { itemsSoporte } from "../../constants/soporte";
import { descargarManual, subirArchivoManual } from "../functions/Soporte";
import {
  Snackbar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
  Box,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CustomButton from "../../ui/button/Button";
import ModalSubirArchivo from "../../ui/ModalSubirArchivo";

const ManualesImplementacion = ({ API_URL }) => {
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [type, setType] = useState(null);

  const [seguridadPdf, setSeguridadPdf] = useState({
    url: null,
    loading: false,
    fetched: false,
  });
  const [instalacionesPdf, setInstalacionesPdf] = useState({
    url: null,
    loading: false,
    fetched: false,
  });

  const fetchPdf = async (tipoManual, setState) => {
    try {
      setState((prev) => ({ ...prev, loading: true }));
      const blob = await descargarManual(API_URL, tipoManual);
      const url = URL.createObjectURL(blob);
      setState({ url, loading: false, fetched: true });
    } catch (error) {
      setState((prev) => ({ ...prev, loading: false }));
      setSnackbarMessage(`Error al cargar el manual de ${tipoManual}`);
      setShowSnackbar(true);
    }
  };

  const handleAccordionChange =
    (tipoManual, state, setState) => (event, isExpanded) => {
      if (isExpanded && !state.fetched && !state.loading) {
        fetchPdf(tipoManual, setState);
      }
    };

  useEffect(() => {
    return () => {
      if (seguridadPdf.url) URL.revokeObjectURL(seguridadPdf.url.split("#")[0]);
      if (instalacionesPdf.url)
        URL.revokeObjectURL(instalacionesPdf.url.split("#")[0]);
    };
  }, [seguridadPdf.url, instalacionesPdf.url]);

  const renderPdfContent = (state) => {
    if (state.loading) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="600px"
        >
          <CircularProgress />
        </Box>
      );
    }
    if (state.url) {
      return (
        <iframe
          title="Manual"
          src={state.url}
          width="100%"
          height="600px"
          style={{ border: "none" }}
        />
      );
    }
    return null;
  };

  const handleUploadManual = (file) => {
    if (type && file) {
      subirArchivoManual(API_URL, file, type)
        .then((res) => {
          setSnackbarMessage("Archivo subido correctamente");
          setShowSnackbar(true);
        })
        .catch((err) => {
          setSnackbarMessage("Error al subir el archivo");
          setShowSnackbar(true);
        });
    }
  };

  return (
    <div className="mi-container" style={{ display: "flex", width: "100%" }}>
      <div className="mi-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsSoporte} />
      </div>

      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />

      <ModalSubirArchivo
        open={openModal}
        onClose={() => setOpenModal(false)}
        onConfirm={handleUploadManual}
        accept={{ "application/pdf": [] }}
      />

      <div
        className="mi-main"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          padding: "10px",
          gap: "10px",
        }}
      >
        <h1 className="map-title" style={{ margin: 0 }}>
          Manuales de Implementación y O&M
        </h1>

        <Accordion
          onChange={handleAccordionChange(
            "INSTALACIONES",
            instalacionesPdf,
            setInstalacionesPdf
          )}
        >
          <AccordionSummary
            className="accordion-summary-no-margin"
            expandIcon={<ExpandMoreIcon />}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "230px auto",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: 0,
                  fontFamily: "Nunito",
                }}
              >
                <strong>Manual de Instalaciones</strong>
              </p>
              <div
                style={{
                  backgroundColor: "#223D51",
                  color: "#FFFFFF",
                  padding: "4px 10px",
                  borderRadius: "5px",
                  fontWeight: 700,
                  fontSize: "14px",
                  cursor: "pointer",
                  fontFamily: "Nunito",
                  marginLeft: "20px",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setType("INSTALACIONES");
                  setOpenModal(true);
                }}
              >
                Reemplazar manual
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            {renderPdfContent(instalacionesPdf)}
          </AccordionDetails>
        </Accordion>

        <Accordion
          onChange={handleAccordionChange(
            "CRITERIOS",
            seguridadPdf,
            setSeguridadPdf
          )}
        >
          <AccordionSummary
            className="accordion-summary-no-margin"
            expandIcon={<ExpandMoreIcon />}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "230px auto",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: 0,
                  fontFamily: "Nunito",
                }}
              >
                <strong>Manual de O&M (PENDIENTE)</strong>
              </p>
              <div
                style={{
                  backgroundColor: "#223D51",
                  color: "#FFFFFF",
                  padding: "4px 10px",
                  borderRadius: "5px",
                  fontWeight: 700,
                  fontSize: "14px",
                  cursor: "pointer",
                  fontFamily: "Nunito",
                  marginLeft: "20px",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                Reemplazar manual
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>{renderPdfContent(seguridadPdf)}</AccordionDetails>
        </Accordion>

        <h1 className="map-title" style={{ margin: "10px 0 0 0" }}>
          Link de Encuesta de Satisfacción del Cliente
        </h1>

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Button
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              color: "#223D51",
              borderColor: "#223D51",
            }}
            variant="outlined"
            href="#"
            // target="_blank"
            endIcon={<OpenInNewIcon />}
            size="small"
          >
            Abrir encuesta
          </Button>
          <CustomButton
            background={"#223D51"}
            width={"120px"}
            height={"31px"}
            fontSize={"14px"}
            color={"#FFFFFF"}
            text={"Cambiar URL"}
            fontWeight={700}
            fontStyle={"normal"}
            // onClick={() => setOpenCambiarUrl(true)}
          />
        </div>
      </div>
    </div>
  );
};

export default ManualesImplementacion;
